import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

const ToastMessageContext = createContext({
  toastMessageInfo: {
    toastMessageOpen: false,
    toastMessageContent: '',
    severity: 'success',
    duration: 5000,
  },
  showToastMessage: () => {},
  closeToastMessage: () => {},
});

export const ToastMessageProvider = ({ children }) => {
  const [toastMessageInfo, setToastMessageInfo] = useState({
    toastMessageOpen: false,
    toastMessageContent: '',
    severity: 'success',
    duration: 5000,
  });

  const showToastMessage = (message, severity = 'success', duration = 5000) => {
    setToastMessageInfo((info) => ({ 
      ...info, 
      toastMessageOpen: true, 
      toastMessageContent: message, 
      severity,
      duration
    }));
  };

  const closeToastMessage = () => {
    setToastMessageInfo((info) => ({ 
      ...info, 
      toastMessageOpen: false 
    }));
  };

  return (
    <ToastMessageContext.Provider 
      value={{ 
        toastMessageInfo, 
        showToastMessage, 
        closeToastMessage 
      }}
    >
      {children}
      <Snackbar
        open={toastMessageInfo.toastMessageOpen}
        autoHideDuration={toastMessageInfo.duration}
        onClose={closeToastMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={closeToastMessage} 
          severity={toastMessageInfo.severity}
          sx={{ width: '100%' }}
        >
          {toastMessageInfo.toastMessageContent}
        </Alert>
      </Snackbar>
    </ToastMessageContext.Provider>
  );
};

export const useToastMessage = () => useContext(ToastMessageContext); 